import React, { useState } from 'react';
import ModuleLayout, { ModuleTabMeta } from '../../../components/layout/ModuleLayout';
import '../../../components/layout/ModuleLayout.css';

type TabKey = 'list' | 'actions' | 'roles' | 'rights';

interface UserTabMeta {
  key: TabKey;
  label: string;
  desc: string; // one line short description
  help: string; // richer tooltip help
}

const tabs: UserTabMeta[] = [
  {
    key: 'list',
    label: 'User Listing',
    desc: 'Browse and search system users.',
    help: 'The user listing will provide search, filters, bulk actions and quick status indicators for each user (coming soon).',
  },
  {
    key: 'actions',
    label: 'User Actions',
    desc: 'Atomic permissions catalogue.',
    help: 'Actions represent granular capabilities (create, approve, delete). They form the building blocks of roles for fine-grained access control (coming soon).',
  },
  {
    key: 'roles',
    label: 'User Roles',
    desc: 'Group actions into roles.',
    help: 'Roles cluster related actions to simplify assignment and reduce management overhead. They will later support versioning (coming soon).',
  },
  {
    key: 'rights',
    label: 'User Rights',
    desc: 'Assign roles to users.',
    help: 'Rights map users to one or more roles producing their effective permissions footprint across the platform (coming soon).',
  },
];

const UsersPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabKey>('list');

  const mappedTabs: ModuleTabMeta[] = tabs.map(t => ({ key: t.key, label: t.label, desc: t.desc, help: t.help }));

  return (
    <ModuleLayout
      tabs={mappedTabs}
      activeTab={activeTab}
      onTabChange={(k) => setActiveTab(k as TabKey)}
      renderPanel={(t) => (
        <div className="coming-soon">
          <span className="soon-badge">Coming soon</span>
          <p>This is a placeholder to establish the navigation path and scope. Functionality will be implemented in phases.</p>
        </div>
      )}
      aside={(
        <>
          <div className="aside-card">
            <h3>Insights</h3>
            <p>• 3 pending approvals</p>
            <p>• 2 new users this week</p>
            <p>• Quick prompt: Add your first role</p>
          </div>
          <div className="aside-card">
            <h3>Tips</h3>
            <p>Use roles to group related permissions. Start with common roles like Admin, Approver, Viewer.</p>
            <p>Track activity in the audit log once actions are live.</p>
          </div>
        </>
      )}
    />
  );
};

export default UsersPage;